// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateRequiredPlaceholder-module__wrapper--d31f6","link":"UpdateRequiredPlaceholder-module__link--e96b6"};